module.exports = __webpack_public_path__ + "static/img/c2.f193e7bc.png";